import type { RouteRecordRaw } from 'vue-router'
import FiatWalletsPage from './FiatWalletsPage.vue'

export const fiatWalletsRoutes: RouteRecordRaw[] = [
  {
    path: '/wallets/fiat-wallets',
    name: 'wallets.fiatWallets',
    component: FiatWalletsPage,
    meta: { layout: 'admin', requiresAuth: true },
  },
]
